<template>
  <div class="actions__container">
    <v-toolbar class="actions" data-js="get-height" flat>
      <v-spacer v-if="!isMobileDevice" />
      <LanguageDropdownMenu v-if="!isMobileDevice" />
      <CompanyDropdownMenu />
      <v-spacer v-if="isMobileDevice" />
      <UserDropdownMenu />
    </v-toolbar>
  </div>
</template>

<script>
import mediaQueries from 'mixins/mediaQueries'
import LanguageDropdownMenu from 'components/Navbar/LanguageDropdownMenu'
import CompanyDropdownMenu from 'components/Navbar/CompanyDropdownMenu'
import UserDropdownMenu from 'components/Navbar/UserDropdownMenu'

export default {
  name: 'Actions',
  mixins: [mediaQueries],
  components: {
    LanguageDropdownMenu,
    CompanyDropdownMenu,
    UserDropdownMenu
  },
  computed: {
    isMobileDevice () {
      return this.isMobile || this.isTablet
    }
  }
}
</script>

<style lang="scss">
.theme--light.v-toolbar.v-sheet.actions {
  background-color: var(--gray-7);
  height: auto !important;
  padding-top: 56px;

  @media (min-width: 961px) {
    background-color: $white;
    padding-top: 0;
  }
}

.actions__container {

  .v-toolbar__content {
    background-color: $white;
    padding: 0;
  }
}
</style>
